import React, { useMemo } from "react";

import { PropertyWarrantyStatus } from "constants/field-values";

interface StatusTagProps {
  status: PropertyWarrantyStatus;
}

const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const tag = useMemo(() => {
    switch (status) {
      case PropertyWarrantyStatus.Active:
        return (
          <div className="status-active-container">
            <span className="status-ending-tag-text">
              {PropertyWarrantyStatus.Active}
            </span>
          </div>
        );
      case PropertyWarrantyStatus.ExpiringSoon:
        return (
          <div className="status-ending-container">
            <span className="status-ending-tag-text">
              {PropertyWarrantyStatus.ExpiringSoon}
            </span>
          </div>
        );
      case PropertyWarrantyStatus.Expired:
        return (
          <div className="status-active-container">
            <span className="status-expired-tag-text">
              {PropertyWarrantyStatus.Expired}
            </span>
          </div>
        );
      default:
        return null;
    }
  }, [status]);

  return tag;
};

export default StatusTag;
